// modules/teamMembers.js
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;

if (ScrollTrigger) {
    try {
        gsap.registerPlugin(ScrollTrigger);
    } catch (e) {}
}

/**
 * Team members: fade-in timelines on scroll (text) + subtle photo reveal
 * - Анімую: .member-role, .member-name, .member-bio, .member-stats .stat
 * - Фото: легкий scale 1.06 -> 1.0 + fade-in
 * - Поважає prefers-reduced-motion
 * - Повертає cleanup-функцію (kill всіх ScrollTrigger/GSAP інстансів для секцій)
 */
export default function initTeamMembers() {
    const SECT = ".team-members";
    const sections = document.querySelectorAll(SECT);
    if (!sections.length) return () => {};

    const prefersReduced = (
        document.documentElement.dataset.ignorePrm === '1'
    ) ? false : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const triggers = [];
    const tweens = [];

    // helper: collect & register tween/trigger to cleanup later
    const track = (obj) => {
        if (obj?.vars?.scrollTrigger) triggers.push(obj.vars.scrollTrigger);
        tweens.push(obj);
        return obj;
    };

    sections.forEach((sec) => {
        // 1) Заголовок секції плавно з’являється
        const title = sec.querySelector(".section-title");
        if (title && !prefersReduced) {
            track(
                gsap.from(title, {
                    autoAlpha: 0,
                    y: 12,
                    duration: 0.5,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: title,
                        start: "top 85%",
                        toggleActions: "play none none reverse",
                    },
                })
            );
        }

        // 2) Карти учасників
        const cards = sec.querySelectorAll(".member-card");
        cards.forEach((card, idx) => {
            // елементи всередині картки
            const photo = card.querySelector(".member-photo");
            const role  = card.querySelector(".member-role");
            const name  = card.querySelector(".member-name");
            const bio   = card.querySelector(".member-bio");
            const stats = [...card.querySelectorAll(".member-stats .stat")];

            if (prefersReduced) {
                // Без анімацій — просто впевнитися, що все видиме
                gsap.set([card, photo, role, name, bio, stats], { clearProps: "all" });
                return;
            }

            // Трохи різний delay по картках для живішого відчуття
            const baseDelay = Math.min(idx * 0.04, 0.2);

            // TL для однієї картки
            const tl = gsap.timeline({
                defaults: { ease: "power2.out" },
                scrollTrigger: {
                    trigger: card,
                    start: "top 80%",
                    end: "bottom 60%",
                    toggleActions: "play none none reverse",
                    // markers: true, // розкоментуй для дебагу
                },
            });

            // Фото — делікатний reveal
            if (photo) {
                tl.from(photo, { autoAlpha: 0, scale: 1.06, duration: 0.55 }, baseDelay);
            }

            // Текстові блоки — послідовно, короткими кроками
            if (role) {
                tl.from(role, { autoAlpha: 0, y: 10, duration: 0.3 }, "<+=0.04");
            }
            if (name) {
                tl.from(name, { autoAlpha: 0, y: 12, duration: 0.35 }, "<+=0.02");
            }
            if (bio) {
                tl.from(bio, { autoAlpha: 0, y: 12, duration: 0.35 }, "<+=0.02");
            }
            if (stats.length) {
                tl.from(stats, { autoAlpha: 0, y: 10, duration: 0.28, stagger: 0.08 }, "<+=0.06");
            }

            // збережемо для подальшого прибирання
            tweens.push(tl);
            triggers.push(tl.scrollTrigger);
        });
    });

    // cleanup — kill all
    return function destroyTeamMembers() {
        triggers.forEach((t) => t && t.kill());
        tweens.forEach((tw) => tw && tw.kill());
    };
}
